import { authHeader, handleResponse, handleError } from '../helper';
import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";


export const referenceDataService = {
    getMasterData,
    getGuestMasterdata,
    getAdminData,
    getAdminScoutData,
    getDashboardData,
    getAllWatchList,
    getAllWatchLists,
    getRefStatRefereeList,
    getMasterDataByName,
    getPoolList,
    getUsersList,
    getCountry,
    getState,
    savePool,
    getRoles,
    getSignalRUrl,
    savePoolDashboardStatus,
    getSeasonDates,
    SavetEventClinician,
    getAllEventClinicialList,
    getGeoJSONData,
    getRegionalOfficeList,
    saveAppConfig,
    getAppConfig,
    getRefereesList,
    getAuditTypes,
    getAllOnlyWatchLists,
    getRoleCodes,
    getExperienceTypeMaster,
    getExperienceLevelMaster,
    getGameCountMaster,
    getTimezoneMaster,
    getSchoolLevelMaster,
    getCountryList,
    getCommunicationCategoryList
};
function getSignalRUrl() {
    return APIHelper.signalRUrl();
}

function getRoles() {
    return APIHelper.get(APIURLConstants.GET_ROLES, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getRoleCodes() {
    return APIHelper.get(APIURLConstants.GET_ROLE_CODES, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}
function getRefStatRefereeList() {
    return APIHelper.get(APIURLConstants.GET_REFSTATS_DATA, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getMasterData() {
    return APIHelper.get(APIURLConstants.GET_MASTER_DATA, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getGuestMasterdata() {
    return APIHelper.get(APIURLConstants.GET_GUEST_MASTER_DATA, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function getMasterDataByName(name) {
    let postdata = { "masterGroupName": name }
    return APIHelper.post(APIURLConstants.GET_MASTER_DATA_BY_NAME, postdata, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getPoolList() {
    let postdata = { "masterGroupName": "Pool" }
    return APIHelper.post(APIURLConstants.GET_ALL_POOLS, postdata, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getUsersList() {
    return APIHelper.get(APIURLConstants.GET_ALL_USERS, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getAdminData() {
    return APIHelper.get(APIURLConstants.GET_ADMIN_USERS, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getAdminScoutData() {
    return APIHelper.get(APIURLConstants.GET_ADMIN_SCOUT_USERS, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getDashboardData() {
    return APIHelper.get(APIURLConstants.GET_DASHBOARD_DATA, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function getAllWatchList(scoutUID) {
    //let postdata = { "scoutUID" : scoutUID}
    return APIHelper.get(APIURLConstants.GET_ALL_WATCHLIST, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function getAllWatchLists() {
    return APIHelper.get(`${APIURLConstants.GET_ALL_WATCHLISTS}`, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function getCountry() {
    let postdata = { "masterGroupName": 'CountryCode' }
    return APIHelper.post(APIURLConstants.GET_MASTER_DATA_BY_NAME, postdata, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function getState() {
    let postdata = { "masterGroupName": 'State' }
    return APIHelper.post(APIURLConstants.GET_MASTER_DATA_BY_NAME, postdata, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function savePool(poolData) {
    return APIHelper.post(APIURLConstants.SAVE_POOL, poolData, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function savePoolDashboardStatus(poolData) {
    return APIHelper.post(APIURLConstants.SAVE_POOL_DASHBOARD_STATUS, poolData, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);

}

function getSeasonDates() {
    return APIHelper.get(APIURLConstants.GET_MASTER_DATA_SEASONDATES, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function SavetEventClinician(data) {
    return APIHelper.post(APIURLConstants.SAVE_EVENT_CLINICIAL, data, authHeader())
        .then(result => {
            return result;
        }).catch(handleError);
}

function getAllEventClinicialList(data) {
    return APIHelper.post(APIURLConstants.GET_ALL_EVENT_CLINICIAL, data, authHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function getGeoJSONData() {
    return APIHelper.get(APIURLConstants.GET_ALL_STATES, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getRegionalOfficeList(data) {
    return APIHelper.get(APIURLConstants.GET_REGIONAL_OFFICE, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getAppConfig(configKey) {
    return APIHelper.post(APIURLConstants.GET_APPCONFIG, configKey, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function saveAppConfig(configdata) {
    return APIHelper.post(APIURLConstants.SAVE_APPCONFIG, configdata, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getRefereesList(data) {
    return APIHelper.get(APIURLConstants.GET_REFEREE, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getAuditTypes() {
    return APIHelper.get(APIURLConstants.GET_AUDIT_TYPES, authHeader())
    .then(data => {
        return data;
    }).catch(handleError);
}


function getAllOnlyWatchLists() {
    return APIHelper.get(`${APIURLConstants.GET_ALL_ONLY_WATCHLISTS}`, authHeader())
        //.then(handleResponse)
        .then(data => {
            return data;
        }).catch(handleError);
}

function getExperienceTypeMaster() {
    return APIHelper.get(APIURLConstants.GET_EXPERIENCE_TYPE_MASTER, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getExperienceLevelMaster() {
    return APIHelper.get(APIURLConstants.GET_EXPERIENCE_LEVEL_MASTER, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getGameCountMaster() {
    return APIHelper.get(APIURLConstants.GET_GAMECOUNT_MASTER, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getTimezoneMaster() {
    return APIHelper.get(APIURLConstants.GET_TIMEZONE_MASTER, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getSchoolLevelMaster() {
    return APIHelper.get(APIURLConstants.GET_SCHOOL_LEVEL_MASTER, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getCountryList() {
    return APIHelper.get(APIURLConstants.GET_COUNTRY_LIST, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}

function getCommunicationCategoryList() {
    return APIHelper.get(APIURLConstants.GET_CUMMUNICATION_CATEGORY_MASTER, authHeader())
        .then(data => {
            return data.data;
        }).catch(handleError);
}